import { Component, OnDestroy, OnInit } from '@angular/core';
import { DropDownIcon, DropDownOption } from '@kion/libs/shared/ui/src/lib/shared/elements/drop-down/drop-down.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { CmsComponentsFacade } from '@kion/data-access/data-access-cms-components';
import { CmsComponent, CmsLanguageComponent } from '@kion/data-models';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { CmsConfig } from '../../config/cms.config';
import { SubSink } from 'subsink';
import { Router } from '@angular/router';
import {CookieKeys} from "@kion/core";

@Component({
  selector: 'kion-cms-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss']
})
export class LanguageSwitchComponent implements OnInit, OnDestroy {

  icon: DropDownIcon = {
    icon: 'assets/icons/globe_icon.svg',
    title: 'globe_icon',
    alt: 'globe_icon'
  };

  options$: Observable<DropDownOption[]>;
  component: CmsLanguageComponent;

  activeLang$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  private subSink: SubSink;

  constructor(
    private cmsComponentsFacade: CmsComponentsFacade,
    private cookieService: CookieService,
    private cmsConfig: CmsConfig,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    const languages = this.component.languages.split(' ');
    this.cmsComponentsFacade.loadByIds(languages, languages.join('_'));
    this.options$ = this.cmsComponentsFacade.all$.pipe(
      map(
        (components) =>   components.filter(
          (component: CmsComponent) => languages.includes(component.uid)
        ).sort(
          (a, b) => {
            const indexA = languages.indexOf(a.uid);
            const indexB = languages.indexOf(b.uid);
            return indexA < indexB ? -1 : 1;
          }
        )
      ),
      map(
        (components) => {
          // @ts-ignore
          return components.map(
            (component: any, index: number, all) => {
              let selectableLang = null;
              if (all.filter((c: any) => c.language.isocode.substring(2) === this.translateService.getBrowserCultureLang().substring(-2)).length === 0) {
                selectableLang = (all[0] as any).language.isocode;
              }
              if (this.cookieService.get(CookieKeys.LANGUAGE)) {
                selectableLang = this.cookieService.get(CookieKeys.LANGUAGE);
              }
              if (component.language) {
                return {
                  key: component.language.isocode,
                  value: component.language.nativeName,
                  selected: component.language.isocode === selectableLang ||
                    this.cookieService.get(CookieKeys.LANGUAGE) === component.language.isocode,
                }
              }
            }
          )
        }
      )
    );
    this.subSink.sink = this.options$.subscribe(availableLanguages => {
      const selectedLanguage = availableLanguages.find(language => language.selected);
      if (selectedLanguage) {
        if (!this.cookieService.get(CookieKeys.LANGUAGE)) {
          const detectedAvailableLanguage = availableLanguages.find(
             language => language.key.substring(0, 2) === this.translateService.getBrowserCultureLang().substring(-2));
          if (detectedAvailableLanguage) {
             this.selected(detectedAvailableLanguage, true);
            return;
          }
        }
        this.translateService.use(selectedLanguage.key);
        this.activeLang$.next(selectedLanguage.key.substring(0, 2))
      }
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  selected(option: DropDownOption, isInitial?: boolean) {
    this.translateService.use(option.key);
    this.cookieService.set(CookieKeys.LANGUAGE, option.key, 30, this.cmsConfig.basePath, null,
       true, 'Strict');
    this.cookieService.set(CookieKeys.SET_IDP_LANGUAGE, isInitial ? 'true' : 'false', 30,
       this.cmsConfig.basePath, null, true, 'Strict');
    window.location.reload();
    this.options$ = this.options$.pipe(
      map(
        (options: DropDownOption[]) =>  options.map(
          (o) => ({ ...o, selected: o.key === option.key })
        )
      )
    )
  }
}
